// To be used for common shared services, filters, etc used across the app
export const base = angular.module('base', [

]);



/** WEBPACK FOOTER **
 ** ./src/app/shared/base/base.js
 **/